import { render } from "./thinkBuyGoods.vue?vue&type=template&id=a45e3034&scoped=true"
import script from "./thinkBuyGoods.vue?vue&type=script&lang=js"
export * from "./thinkBuyGoods.vue?vue&type=script&lang=js"

import "./thinkBuyGoods.vue?vue&type=style&index=0&id=a45e3034&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a45e3034"]])

export default __exports__